import angular from 'angular';
import template from './templates/modal-window.tpl.html';
import ModalWindowController from './modal-window-controller';

export default class ModalWindowService {

  static get $inject() {
    return ['$uibModal', '$rootScope'];
  }

  constructor($uibModal, $rootScope) {
    this.$modal = $uibModal;
    this.$rootScope = $rootScope;
  }

  open(options) {
    if (!angular.isObject(options)) {
      throw new Error('An options object was not passed to modelWindow.open');
    }

    if (!options.component && !(options.template || options.templateUrl)) {
      throw new Error('Modal Window component or template or templateUrl option required');
    }

    const scope = this.$rootScope.$new();

    scope.options = options;

    options.contentController = options.controller;
    options.contentScope = options.scope;
    options.contentControllerAs = options.controllerAs;
    options.contentTemplate = options.template;
    options.contentTemplateUrl = options.templateUrl;
    options.contentResolve = options.resolve;
    options.contentComponent = options.component;
    Reflect.deleteProperty(options, 'resolve');
    Reflect.deleteProperty(options, 'component');

    // create a new bootstrap ui modal instance with akamai options
    options.instance = this.$modal.open(angular.extend(options, {
      scope,
      template,
      controller: ModalWindowController,
      controllerAs: 'modalWindow',
      backdrop: 'static'
    }));

    return options.instance;
  }

}
